import { MASTER_CATEGORIES, masterCategory } from '../utils/requestTheme';

/** Badge kategori IPR/OPR untuk baris tabel master data. */
export function CategoryBadge({ value, testId }) {
  const c = masterCategory(value);
  return <span className={`inline-block rounded px-2 py-0.5 text-xs font-semibold ${c.badge}`} data-testid={testId}>{c.label}</span>;
}

/**
 * Filter kategori di halaman master: Semua / IPR / OPR.
 * Bila `locked` (approval bercakupan), hanya badge kategorinya yang tampil.
 */
export function CategoryFilter({ value, onChange, locked, testId = 'category-filter' }) {
  if (locked) {
    return (
      <div className="flex items-center gap-2 text-sm text-slate-600" data-testid={`${testId}-locked`}>
        Kategori: <CategoryBadge value={locked} />
      </div>
    );
  }
  const opts = [{ value: '', label: 'Semua' }, ...MASTER_CATEGORIES];
  return (
    <div className="inline-flex rounded-md border bg-white p-0.5" data-testid={testId}>
      {opts.map((o) => (
        <button key={o.value || 'all'} type="button" onClick={() => onChange(o.value)}
          className={`px-3 py-1 text-sm rounded ${value === o.value ? 'bg-slate-800 text-white' : 'text-slate-600 hover:bg-slate-100'}`}
          data-testid={`${testId}-${o.value || 'all'}`}>
          {o.label}
        </button>
      ))}
    </div>
  );
}

/** Pilihan kategori wajib di form tambah/edit. */
export function CategoryPicker({ value, onChange, locked, testId = 'category-picker' }) {
  return (
    <div className="space-y-1">
      <p className="text-sm font-medium">Kategori *</p>
      <div className="flex gap-2" data-testid={testId}>
        {MASTER_CATEGORIES.map((c) => {
          const active = (locked || value) === c.value;
          const disabled = !!locked && locked !== c.value;
          return (
            <button key={c.value} type="button" disabled={disabled} onClick={() => onChange(c.value)}
              className={`flex-1 rounded-md border px-3 py-2 text-sm font-semibold transition ${active ? c.badge + ' ring-2 ring-offset-1 ring-slate-400' : 'bg-white text-slate-600 hover:bg-slate-50'} ${disabled ? 'opacity-40 cursor-not-allowed' : ''}`}
              data-testid={`${testId}-${c.value}`}>
              {c.label}
              <span className="block text-[11px] font-normal">{c.value === 'ipr' ? 'Muncul di form Internal' : 'Muncul di form Operasional'}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
}
